/**
 * État vide uniformisé (HTML) : tuile d'icône, ou mascotte souris Veille.png sans icône.
 */
export function renderEmptyStateHTML(options = {}) {
    const {
        title = 'Aucune donnée',
        message = 'Aucune donnée disponible pour le moment.',
        icon = null,
        buttonHTML = '',
        variant = 'default',
        showMascot = true,
        frameless = false, // Mode sans cadre comme Snapshot
    } = options;

    const containerClass = frameless
        ? 'empty-state-unified empty-state-frameless'
        : `empty-state-unified empty-state-variant-${variant}`;

    // Redesign : une tuile d'icône calme ; la mascotte (en petit) seulement sans icône
    let visual = '';
    if (icon) {
        visual = `
            <div class="empty-state-icon rd-empty-icon rd-empty-icon-${variant}" aria-hidden="true">
                <span class="material-symbols-outlined">${icon}</span>
            </div>
        `;
    } else if (showMascot) {
        visual = `
            <div class="empty-state-mascot-container rd-empty-mascot" aria-hidden="true">
                <img src="/images/souris/VEILLE.png" alt="" class="empty-state-mascot" />
            </div>
        `;
    }

    return `
        <div class="${containerClass} rd-empty rd-empty-${variant}">
            ${visual}
            <div class="empty-state-content">
                <h3 class="empty-state-title">${title}</h3>
                ${message ? `<p class="empty-state-text">${message}</p>` : ''}
                ${buttonHTML || ''}
            </div>
        </div>
    `;
}

/**
 * Variantes prédéfinies des sections admin
 */
export const EmptyStatePresets = {
    adminSupport: {
        title: 'Aucun contact support',
        message: 'Aucun contact support pour le moment. Les demandes d\'assistance apparaîtront ici.',
        icon: 'support_agent',
        variant: 'default',
    },
    adminExecutions: {
        title: 'Aucune exécution',
        message: 'Aucune exécution enregistrée pour le moment. Les exécutions de scénarios apparaîtront ici.',
        icon: 'play_arrow',
        variant: 'default',
    },
    adminEvents: {
        title: 'Aucun événement',
        message: 'Aucun événement à afficher pour le moment. L\'activité du système apparaîtra ici.',
        icon: 'history',
        variant: 'default',
    },
    adminRequests: {
        title: 'Aucune demande',
        message: 'Aucune demande pour le moment. Les demandes des utilisateurs apparaîtront ici.',
        icon: 'request_quote',
        variant: 'default',
    },
    adminUsers: {
        title: 'Aucun utilisateur',
        message: 'Aucun utilisateur trouvé. Les utilisateurs enregistrés apparaîtront ici.',
        icon: 'people',
        variant: 'default',
    },
    adminErrors: {
        title: 'Aucune erreur',
        message: 'Aucune erreur enregistrée. Excellente nouvelle ! Le système fonctionne correctement.',
        icon: 'check_circle',
        variant: 'success',
    },
    adminEmails: {
        title: 'Aucun email',
        message: 'Aucun email enregistré pour le moment. L\'historique des envois d\'emails apparaîtra ici.',
        icon: 'mail',
        variant: 'default',
    },
};

